
  // Export
  module.exports =
  {

    // Search scripts
    search:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#applications'), APPLICATION._PATH_PREFIX + 'backhaul-dash/applications', 'BackhaulDash', 'applications')        
      }

    },
    searchRange:
    {

      // Method-wide scripts
      _init: function ()
      {
        APPLICATION._APPLICATION.load($('#range-applications'), APPLICATION._PATH_PREFIX + 'backhaul-dash/range-applications?' + $('#range-applications').data(APPLICATION._DATA_PREFIX + 'query_string'), 'BackhaulDash', 'range-applications')        
      }

    },

    // Applications scripts
    applications:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Process links
        APPLICATION._APPLICATION.processLinks('#applications', 'BackhaulDash', 'applications')

      }

    },

    // Edit scripts
    edit:
    {

      // Method-wide scripts
      _init: function ()
      {
  
        // On clicking the calendar
        $('#duct_plan_date_calendar, #duct_delivery_date_calendar').not('.js-ignore').click(function ()
        {
  
          // Get the form
          var form = $(this).closest('form').serialize()
  
          // Get the application ID
          var application_id = $(this).closest('form').attr('data-' + APPLICATION._DATA_PREFIX + 'application_id')

          // Get the input
          var input = $(this).attr('for')
  
          // Store the datepicker
          APPLICATION._datepicker = function (date)
          {
  
            // Set the due date
            form += '&' + input  + '=' + date
  
            // Show the custom modal
            APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'backhaul-dash/edit/' + application_id + '?' + form, 'BackhaulDash', 'edit')
  
          }
  
          // Get the parts
          var parts = $('#' + input).val().split('/')
  
          // Open the calendar
          APPLICATION._APPLICATION.customModal(APPLICATION._PATH_PREFIX + 'calendar/month/' + parts[2] + '/' + parts[1] + '?modal=1&date=' + parts[2] + '-' + parts[1] + '-' + parts[0], 'Calendar', 'month')  
        }
        ).addClass('js-ignore')

      }

    }

  }